/**
 * Block: new-proparent-bottom
 * Initialize Slick slider for the colored cards in .new-proparent-bottom-slider.
 * Slick is loaded globally via WordPress (jQuery + slick.js).
 */

export function init() {
    const sliders = document.querySelectorAll('.new-proparent-bottom-slider');
    if (!sliders.length) return;
    if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

    const $ = jQuery;

    sliders.forEach((el) => {
        if ($(el).hasClass('slick-initialized')) return;

        $(el).slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            infinite: false,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 1009,
                    settings: {
                        slidesToShow: 1,
                    },
                },
            ],
        });
    });
}
